module.exports = __webpack_public_path__ + "static/media/atharva_sardesai.86abd2d0.png";